import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/services/api';
import { Test } from '@/types';
import PageLayout from '@/shared/ui/layout/PageLayout';
import { LinkCard, CardTitle, CardDescription, CardSection } from '@/shared/ui/card';
import './styles.css';

const TestList: React.FC = () => {
  const [tests, setTests] = useState<Test[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const testsData = await api.tests.getAll();
        setTests(testsData);
        setError(null);
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err.message);
        } else {
          setError('Failed to fetch tests');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchTests();
  }, []);

  const getUniqueCategories = (tasks: any[]) => {
    return Array.from(new Set(tasks.map(task => task.category))).filter(Boolean);
  };

  const formatDate = (date: Date | string | undefined) => {
    if (!date) return 'Never';
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <PageLayout
      title="Tests"
      actions={
        <Link to="/tests/new" className="button">Create</Link>
      }
    >
      {tests.length === 0 ? (
        <p>No tests found. Create your first test!</p>
      ) : (
        <div className="tests-grid">
          {tests.map(test => (
            <LinkCard 
              key={test._id} 
              to={`/tests/${test._id}`}
            >
              <CardTitle title={test.name} />
              <CardDescription maxLines={2}>
                {test.description}
              </CardDescription>
              <CardSection>
                <CardDescription variant="meta">
                  <span className="test-stats">
                    {Array.isArray(test.tasks) ? test.tasks.length : 0} Tasks
                  </span>
                  <span className="test-stats">
                    {getUniqueCategories(test.tasks || []).length} Categories
                  </span>
                </CardDescription>
                <CardDescription variant="meta" className="test-date">
                  Updated {formatDate(test.updatedAt)}
                </CardDescription>
              </CardSection>
            </LinkCard>
          ))}
        </div>
      )}
    </PageLayout>
  );
};

export default TestList; 